import styled from 'styled-components';

import {colors} from '@app/styles/theme';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const ValueWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 20px;
    box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.15);
    background: ${colors.white};

    & > div {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
        gap: 12px;
    }
`;

export const Value = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;

    & > h3 {
        font-weight: 400;
        font-size: 14px;
        margin: 0;
        color: ${colors.textPrimary};
    }

    & > span {
        font-size: 16px;
        font-weight: 500;
        color: #24262a;
    }
`;
